import { Box, Button, Grid, makeStyles } from '@material-ui/core'
import moment from 'moment'
import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import { adminPlanOfferCodesByDateConstants } from '../../../../constants/formConstants/adminFormConstants'
import { dashboardOfferCodeCountByOfferIdentifierHeadCells, dashboardPlanHeadCells } from '../../../../constants/headCells/dashboardHeadCells'
import { getOfferCodeCount, getOfferCodeCountByOfferIdentifier, getTotalCountByPlanId, getTotalSales, getTotalSellBYPlanId } from '../../../../services/giftingService'
import { getAllOfferPlans } from '../../../../services/masterDataService'
import icons from '../../../../utils/icons'
import { formatDateForInputFields, getFormattedPrice } from '../../../../utils/other'
import AppCard from '../../../commons/Card/AppCard'
import GenerateFormHook from '../../../commons/GenerateFormHook'
import ScreenWrapper from '../../../commons/ScreenWrapper'
import Table from '../../../commons/Table/dataTable/Table'
import Text from '../../../commons/Text'

const useStyles = makeStyles((theme) => ({
    gridItem: {
        [theme.breakpoints.up("sm")]: {
            paddingRight: '1rem'
        },
    },
    cardContent: {
        fontSize: '2rem',
        fontWeight: 400,
        color: theme.palette.primary.main,
        fontFamily: 'Montserrat, sans-serif',
    },
    cardHeading: {
        color: theme.palette.primary.main,
        fontSize: 14,
        fontFamily: 'Montserrat, sans-serif',
        textTransform: 'uppercase'
    },
    loaderIcon: {
        color: theme.palette.primary.main,
        width: '1.75rem',
        margin: '0.5rem 0',
        height: 'auto',
    },
    pointer: {
        cursor: 'pointer'
    },
    icon: {
        alignSelf: 'center'
    },
    screenTitle: {
        marginBottom: '3rem',
        [theme.breakpoints.down("sm")]: {
            fontSize: '1.35rem'
        }
    },
}))

const AdminDashboardScreen = () => {
    const classes = useStyles();
    const [totalSales, setTotalSales] = React.useState(0);
    const [offerCodeCount, setOfferCodeCount] = React.useState(0);
    const [plans, setPlans] = React.useState([]);
    const [plansTableDataIsLoading, setPlansTableDataIsLoading] = React.useState(false)
    const [offerCodeCountByOfferIdentifier, setOfferCodeCountByOfferIdentifier] = React.useState([])
    const [offerCodeCountTableIsLoading, setOfferCodeCountTableIsLoading] = React.useState(false)
    const DEFAULT_FROM_DATE = `${(new Date().getFullYear())}-01-01`
    const DEFAULT_TO_DATE = moment().format('YYYY-MM-DD')
    const methods = useForm();
    const jwt = useSelector(state => state.auth.admin.jwt)

    const handleFormSubmit = async (data) => {
        if (!!data.fromDate && !!data.toDate) {
            setPlansTableDataIsLoading(true)
            // data.fromDate = moment(data.fromDate).toDate().getTime()
            // data.toDate = moment(data.toDate).toDate().getTime()

            const plansForTable = []
            const offerCodeCountTableData = []
            for (let i = 0; i < plans.length; i++) {
                const plan = plans[i];

                const totalCountByPlanIdResp = await getTotalCountByPlanId({
                    id: plan.plan_id,
                    fromDate: data.fromDate,
                    toDate: data.toDate,
                    jwt
                })
                const totalSellBYPlanIdResp = await getTotalSellBYPlanId(plan.plan_id, jwt)
                // const offerCodeCountResp = await getOfferCodeCountByOfferIdentifier(plan.offer_identifier)

                const tablePlan = {
                    ...plan,
                    revenue: totalSellBYPlanIdResp ? totalSellBYPlanIdResp.payload.find(sale => sale.is_paid === 1)?.total_sell / 100 || 0 : 0,
                    totalCount: totalCountByPlanIdResp ? totalCountByPlanIdResp.payload.find(sale => sale.is_paid === 1)?.total_sell || 0 : 0,
                }

                // const totalClaimCount = offerCodeCountResp ? offerCodeCountResp.payload.find(offer => offer.is_claimed === 1) : undefined
                // const totalUnClaimCount = offerCodeCountResp ? offerCodeCountResp.payload.find(offer => offer.is_claimed === 0) : undefined
                // const offerTableData = {
                //     ...plan,
                //     offerIdentifier: plan.offer_identifier,
                //     totalClaimCount: totalClaimCount ? totalClaimCount.total_offer_code_count : 0,
                //     totalUnClaimCount: totalUnClaimCount ? totalUnClaimCount.total_offer_code_count : 0,
                // }
                plansForTable.push(tablePlan)
                // offerCodeCountTableData.push(offerTableData)
            }
            setPlans(plansForTable)
            setPlansTableDataIsLoading(false)
        }
    }


    const fetchAllData = async () => {
        getTotalSales(jwt).then(response => {
            if (response) {
                if (response.payload) {
                    setTotalSales(response.payload.find(sale => sale.is_paid === 1).total_sell / 100)
                }
            }
        })
        getOfferCodeCount(jwt).then(response => {
            if (response) {
                if (response.payload) {
                    console.log('TOTAL CLAIMED OFFER CODES', response.payload);
                    const sale = response.payload.find(sale => sale.is_claimed === 1)
                    setOfferCodeCount(sale ? sale.total_offer_code_count : 0)
                }
            }
        })

        try {
            setPlansTableDataIsLoading(true)
            setOfferCodeCountTableIsLoading(true)
            const allPlans = await getAllOfferPlans()
            const plansForTable = []
            const offerCodeCountTableData = []

            for (let i = 0; i < allPlans.length; i++) {
                const plan = allPlans[i];

                const totalCountByPlanIdResp = await getTotalCountByPlanId({
                    id: plan.plan_id,
                    fromDate: DEFAULT_FROM_DATE,
                    toDate: DEFAULT_TO_DATE,
                    jwt
                })
                const totalSellBYPlanIdResp = await getTotalSellBYPlanId(plan.plan_id, jwt)
                const offerCodeCountResp = await getOfferCodeCountByOfferIdentifier(plan.offer_identifier, jwt)

                const tablePlan = {
                    ...plan,
                    revenue: totalSellBYPlanIdResp ? totalSellBYPlanIdResp.payload.find(sale => sale.is_paid === 1)?.total_sell / 100 : 0,
                    totalCount: totalCountByPlanIdResp ? totalCountByPlanIdResp.payload.find(sale => sale.is_paid === 1)?.total_sell : 0,
                }

                const totalClaimCount = offerCodeCountResp ? offerCodeCountResp.payload.find(offer => offer.is_claimed === 1) : undefined
                const totalUnClaimCount = offerCodeCountResp ? offerCodeCountResp.payload.find(offer => offer.is_claimed === 0) : undefined
                const offerTableData = {
                    ...plan,
                    offerIdentifier: plan.offer_identifier,
                    totalClaimCount: totalClaimCount ? totalClaimCount.total_offer_code_count : 0,
                    totalUnClaimCount: totalUnClaimCount ? totalUnClaimCount.total_offer_code_count : 0,
                }

                plansForTable.push(tablePlan)
                offerCodeCountTableData.push(offerTableData)
                // if (plan.is_active === 1) {
                // }

            }
            setPlans(plansForTable)
            setOfferCodeCountByOfferIdentifier(offerCodeCountTableData)
            setPlansTableDataIsLoading(false)
            setOfferCodeCountTableIsLoading(false)
        } catch (error) {
            console.log(error);
        }
    }


    React.useEffect(() => {
        fetchAllData()
        methods.reset({
            fromDate: formatDateForInputFields(DEFAULT_FROM_DATE.split('-').reverse().join()),
            toDate: formatDateForInputFields(DEFAULT_TO_DATE.split('-').reverse().join()),
        })
    }, [])

    return (
        <ScreenWrapper
            pageTitle='Dashboard'
            hasForm
        >
            <Grid container style={{ marginBottom: 16 }}>
                <Grid item xs={12} sm={6} lg={3} className={classes.gridItem}>
                    <AppCard
                        aspectRatio={8 / 16}
                        heading='Total Sales'
                        headingProps={{ className: classes.cardHeading }}
                        mainContent={
                            <Text variant='h2' className={classes.cardContent}>₹{getFormattedPrice(totalSales, 0)}</Text>
                        }
                        imageUrl={icons.CommissionSvg}
                        imageProps={{ className: classes.icon }}
                    />
                </Grid>
                <Grid item xs={12} sm={6} lg={3} className={classes.gridItem}>
                    <AppCard
                        aspectRatio={8 / 16}
                        heading='Total claimed offer codes'
                        headingProps={{ className: classes.cardHeading }}
                        mainContent={
                            <Text variant='h2' className={classes.cardContent}>{offerCodeCount}</Text>
                        }
                        imageUrl={icons.SubscribersSvg}
                        imageProps={{ className: classes.icon }}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Table
                        headCells={dashboardPlanHeadCells}
                        tableData={plans}
                        crud={{}}
                        tableName='Revenue by plan'
                        isLoading={plansTableDataIsLoading}
                        showDownloadButton
                    />
                    <FormProvider {...methods}>
                        <form onSubmit={methods.handleSubmit(handleFormSubmit)}>
                            <Grid container spacing={3}>
                                <Grid item xs={8}>
                                    <GenerateFormHook control={methods.control} formConstant={adminPlanOfferCodesByDateConstants()} />
                                </Grid>
                                <Grid item xs={4}>
                                    <Box display='flex' alignItems='center' height={'100%'}>
                                        <Button full variant='contained' onClick={methods.handleSubmit(handleFormSubmit)} color='primary' disabled={offerCodeCountTableIsLoading} isLoading={offerCodeCountTableIsLoading}>{!offerCodeCountTableIsLoading ? 'Search' : 'Searching...'}</Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </form>
                    </FormProvider>
                </Grid>

                <Grid item xs={6}>
                    <Table
                        headCells={dashboardOfferCodeCountByOfferIdentifierHeadCells}
                        tableData={offerCodeCountByOfferIdentifier}
                        crud={{}}
                        tableName='Offer Codes Claimed by Offer Identifier'
                        isLoading={offerCodeCountTableIsLoading}
                    />
                </Grid>
            </Grid>
        </ScreenWrapper >
    )
}

export default AdminDashboardScreen
